var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{attrs:{"value":_vm.value,"value-key":"key","size":_vm.size,"clearable":true},on:{"input":function($event){return _vm.change($event)}}},[_c('el-option',{attrs:{"label":"主套餐","value":"main"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"加油包","value":"auxi"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86891ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/card/components/PackageTypeSelect.vue
// module id = null
// module chunks = 